import storage from 'good-storage'

class Cache {
  constructor() {
    this.storage = storage.session;
    this.localStorage = storage;
  }

  getLocal(key, defaultValue) {
    return this.localStorage.get(prefix + key, defaultValue);
  }

  setLocal(key, value) {
    this.localStorage.set(prefix + key, value);
    return value;
  }

  get(key, defaultValue) {
    return this.storage.get(prefix + key, defaultValue);
  }

  set(key, value) {
    this.storage.set(prefix + key, value);
    return value;
  }
}

let prefix = (window.version ? window.version + "_" : '') + "self_";

export default new Cache();



// WEBPACK FOOTER //
// ./src/common/js/cache.js